import { ComponentF } from "../ui";

export const Input: ComponentF<{
  initialValue: string;
  onSubmit: (value: string) => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ entry: props.initialValue });
  C.display.drawText(C.bounds.x, C.bounds.y, state.entry);
  C.handlers.keypress = (key) => {
    if (key === "Delete" || key === "Backspace") {
      setState({ entry: state.entry.substr(0, state.entry.length - 1) });
    } else if (key === "Enter") {
      props.onSubmit(state.entry);
    } else if (key.length === 1) {
      setState({ entry: state.entry + key });
    } else {
      return false;
    }
    return true;
  };
};
